module.exports = __webpack_public_path__ + "pc/static/img/stock.277256cf.png";